// ========== UPDATED header.component.ts ==========

import { Component, OnInit, HostListener, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ScenarioService } from '@app/featured-modules/modeling-predictions/modules/modeling-predictions-shared/scenarios.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { AuthService } from '@sharedServices/auth.service';
import { SessionStorageService } from 'angular-web-storage';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Output() navigationItemClicked: EventEmitter<any> = new EventEmitter<any>();
  userDetails: any = {};
  show: boolean;
  notificationConfig;
  showNotificationIcon: boolean = false;
  userGroup;
  refreshForecastNotifIcon: boolean;
  isLocked = false;

  isAdminActive: boolean = false;
  isHomeActive: boolean = false;

  showAdmin: boolean = false;

  constructor(
    public router: Router, 
    private authService: AuthService, 
    public scenarioService: ScenarioService, 
    private localStorage: SessionStorageService, 
    private notificationService: NotificationService
  ) {
    this.show = false;
  }
ngOnInit(): void {
  this.userDetails = this.authService.getUserDetails();
  this.showAdmin = this.authService.isAdminUser();

  // console.log(this.userDetails);
  this.scenarioService.fetchUserActiveValue.subscribe(value => {
    this.showNotificationIcon = value;
  });
  const scenarioDetail = this.localStorage.get('scenario-details');
  const inputRequest = this.localStorage.get('inputRequest');
  this.refreshForecastNotifIcon = scenarioDetail?.forecast_type === 'refresh_forecast' ? true : false;
  if (scenarioDetail) {
    this.notificationService.latestLockStatus.subscribe(val => {
      this.isLocked = val;
    })
  }
  else {
    const lockValue = ((inputRequest?.input_request?.scenario_lock_status === 'False') || (inputRequest?.input_request?.scenario_lock_status == false));
    this.isLocked = lockValue ? false : true;
  }

  // Set initial active state based on current URL
  if (this.router.url.includes('/admin')) {
    this.isAdminActive = true;
    this.isHomeActive = false;
  } else if (this.router.url.includes('/modeling-predictions')) {
    this.isHomeActive = true;
    this.isAdminActive = false;
  }

  this.notificationService.closePanel.subscribe(() => {
    this.cancelFilter()
  })
}

  onProfileClickMe(): void {
    this.show = !this.show;
  }

  removeValue(): any {
    const scenarioDetails = this.localStorage.get('scenario-details');
    if (scenarioDetails) {
      this.notificationService.insertUserActivityDetails(false).then(res => {
        if (res) {
          this.logoutUser();
        }
      });
    } else {
      this.logoutUser();
    }
  }

  logoutUser() {
    this.authService.onLogout();
    this.router.navigate(['/']);
  }

activeDiv(item?: string): void {
  if (item === 'admin') {
    this.isAdminActive = true;
    this.isHomeActive = false;
  } else if (item === 'modeling-predictions') {
    this.isHomeActive = true;
    this.isAdminActive = false;
  }
}
navigate(url: string): void {
  this.navigationItemClicked.emit(url);
}
  checkVisibility(): boolean {
    return true;
  }

  openNotification(): any {
    this.notificationConfig = {};
    const obj = { state: 'open', group: 'group' };
    Object.assign(this.notificationConfig, obj);
    this.notificationConfig = JSON.parse(JSON.stringify(this.notificationConfig));
  }

  cancelFilter(e?): void {
    this.notificationConfig = {};
    const obj = { state: 'closed' };
    this.notificationConfig.state = 'closed';
    Object.assign(this.notificationConfig, obj);
  }

  @HostListener('document:click', ['$event'])
  clickout(event): void {
    if (event.target.tagName === 'IMG') {
      // returns true
    } else {
      this.show = false;
    }
  }
}